<template>
  <a href="javascript:" ondragstart="return false"
     class="btn btn-hollow btn-icon"
     @click="handleClick()"
     style="margin-right: 3px;"
  ><slot></slot></a>
</template>
<script>
  export default {
    name: 'grid-top-menu',
    methods: {
      handleClick() {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-top-menu.vue